import { Routes } from '@angular/router';
import { CandidateAuthGuard } from './guard/candidate-auth.guard';
import { selectLocalStore } from './guard/local-store.guard';
import { ErrorPageComponent } from './site/error/error-page/error-page.component';
import { TroubleshootPageComponent } from './site/error/troubleshoot-page/troubleshoot-page.component';
import { NotFoundComponent } from './site/not-found/not-found.component';
import { PlatformWarningComponent } from './site/platform-warning/platform-warning.component';

export const routes: Routes = [
	{ path: '', loadChildren: () => import('./site/home/home.routes').then(m => m.routes) },
	{ path: 'login', loadChildren: () => import('./site/login/login.routes').then(m => m.routes) },
	{ path: 'tutorial', loadChildren: () => import('./site/tutorial/tutorial.routes').then(m => m.routes) },
	{ path: 'exam', loadChildren: () => import('./site/exam/exam.routes').then(m => m.routes), canMatch: [selectLocalStore('exam')], canLoad: [CandidateAuthGuard] },
	{ path: 'preview', loadChildren: () => import('./site/preview/preview.routes').then(m => m.routes) },
	{ path: 'upload', loadChildren: () => import('./site/upload/upload.routes').then(m => m.routes), canMatch: [selectLocalStore('exam')] },
	{ path: 'connection', loadChildren: () => import('./site/connection/connection.routes').then(m => m.routes) },
	{ path: 'error/:errorCode', component: ErrorPageComponent },
	{ path: 'troubleshoot', component: TroubleshootPageComponent },
	{ path: 'platform', component: PlatformWarningComponent },
	{ path: 'mock', loadChildren: () => import('./site/mock/mock.routes').then(m => m.routes), canMatch: [selectLocalStore('practice')] },
	{ path: 'sample', loadChildren: () => import('./site/sample/sample.routes').then(m => m.routes), canMatch: [selectLocalStore('practice')] },
	{ path: '**', component: NotFoundComponent }
];
